import LoginForm from '../Components/Auth/LoginForm';
import MobileLoginForm from '../Components/Auth/MobileLoginForm';

const Login = () => {
    const isMobile = window.innerWidth <= 640;

    return (
        <>
            {isMobile ? <MobileLoginForm /> : <LoginForm />}
        </>
    );
}

export default Login;